import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
    state:{
        themecolor:localStorage.getItem('ThemeColor')?localStorage.getItem('ThemeColor'):'da2337',//默认为da2337
    },
    mutations:{
        //更新主题颜色
        setThemeColor(state,curcolor){
            alert(curcolor);
            this.state.themecolor = curcolor;
        }
    }
});
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js